import React from "react";
import "dayjs/locale/sv";
import { useIsMobile } from "../../helpers/customHooks";
import { FLAVOR, icons } from "../../helpers/constants";

const InfoSquare = ({ index, total = 0, spec = false, onClick, icon, value, label }) => {
	const MOBILE = useIsMobile();
	const isEven = index % 2 === 0;

	// margins between columns
	const marginClass = isEven ? "pe-2 ps-0" : "ps-2 pe-0";

	// calculate rows
	const itemsPerRow = 2;
	const totalRows = Math.ceil(total / itemsPerRow);
	const currentRow = Math.floor(index / itemsPerRow) + 1;
	const marginB = currentRow < totalRows ? "3" : "0";

	return (
		<div className={`col-${MOBILE ? "6" : "6"} m-0 p-0 ${marginClass} pb-${marginB}`}>
			<div onClick={spec ? (e) => onClick(e) : null} className={`${spec ? "cursor-pointer" : ""} position-relative d-flex flex-column info-square justify-content-center align-items-center bg-white`}>
				<img src={icons[icon] || icons.distance} alt="" className={`size_15 position-absolute top-0 end-0 me-1 mt-1 grey-blue-icon`} />
				<h4 className="primary">{value}</h4>
				<p className="thin dark_grey text-truncate">{label}</p>
			</div>
		</div>
	);
};

export default InfoSquare;
